import { Model } from '@nozbe/watermelondb'
import { field } from '@nozbe/watermelondb/decorators'


export class BullModel extends Model {
  static table = 'bull'

  @field('bullId')
  bullId: string

  @field('breedId')
  breedId: number

  @field('code')
  code: string
  
  @field('name')
  name: string

  @field('nameAndCode')
  nameAndCode: string

  @field('createdAt')
  createdAt: string

  @field('updatedAt')
  updatedAt: string

}
